<template>
  <div class="http-view base-error">
    <div class="http-view-container">
      <h1 class="http-code">{{ httpCode }}</h1>
      <h4 class="http-message">{{ message }}</h4>
      <Button :label="toRoute.text" @click="navigateToDashboardView()" />
    </div>
  </div>
</template>

<script>
import RoutesMixin from "@/utils/routes";

export default {
  name: "HttpError",
  props: {
    httpCode: {
      type: Number,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    toRoute: {
      type: Object,
      required: true,
    },
  },
  mixins: [RoutesMixin],
  methods: {
    navigateToDashboardView() {
      this.to({
        name: this.toRoute.name,
        params: this.toRoute.params,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>